import Cookies from "js-cookie";

import { store, resetSession } from "../store/store";
import { queryClient } from "./queryClient";

// Chaves do localStorage que pertencem à conta logada (lista, paginação, filtros).
const USER_SCOPED_KEYS = {
  currentClinicConnection: null,
  fatestClinicIndex: null,
  currentPageNumber: null,
  patientFilters: null,
  recentDocument: null,
  atd: "null",
  scrollValue: "0",
  totalPages: "0",
  page: "0",
  toConclude: "0",
};

// Apaga tudo o que é da sessão atual antes de entrar com outra conta:
// store do redux (persistido), cache do react-query, localStorage, sessionStorage e cookie.
export function clearUserSession() {
  store.dispatch(resetSession());
  queryClient.clear();

  Object.entries(USER_SCOPED_KEYS).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
  localStorage.removeItem("selectedPatient");
  localStorage.removeItem("selectedClinic");

  sessionStorage.clear();
  Cookies.remove("userMain");
}
